import React, { useState, useEffect } from 'react';
import './App.css';
import Sidebar from './components/Sidebar/Sidebar';
import HomeScreen from './screens/HomeScreen';

function App() {
  const [activeSection, setActiveSection] = useState('home');
  const [darkMode, setDarkMode] = useState(true);

  // Apply dark/light mode class to body
  useEffect(() => {
    if (darkMode) {
      document.body.classList.remove('light-mode');
    } else {
      document.body.classList.add('light-mode');
    }
  }, [darkMode]);

  // Intersection observer for active nav section
  useEffect(() => {
    const sections = document.querySelectorAll('section[id], div[id]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) setActiveSection(entry.target.id);
      });
    }, { threshold: 0.3, rootMargin: '-60px 0px -60px 0px' });

    sections.forEach(s => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="portfolio-wrapper">
      <Sidebar
        activeSection={activeSection}
        darkMode={darkMode}
        toggleMode={() => setDarkMode(prev => !prev)}
      />
      <div className="portfolio-main">
        <HomeScreen />
      </div>
    </div>
  );
}

export default App;
